export const courseCategories = [
  "All",
  "Fire & Emergency Services",
  "Technical & Hazmat",
  "AI & Future Workforce",
  "Leadership & People Development"
];

export const courses = [
  // Fire & Emergency Services
  {
    title: "NFPA 1021 Fire Officer",
    category: "Fire & Emergency Services",
    summary: "Develop leadership, management, and administrative skills for company officers.",
    duration: "Varies by level",
    standards: "NFPA 1021",
    delivery: "Onsite, Blended"
  },
  {
    title: "NFPA 1020 Fire Instructor",
    category: "Fire & Emergency Services",
    summary: "Deliver comprehensive training programs, develop lesson plans, and evaluate performance.",
    duration: "40 Hours",
    standards: "NFPA 1020",
    delivery: "Onsite"
  },
  {
    title: "NFPA 1033 Fire Investigator",
    category: "Fire & Emergency Services",
    summary: "Determine the origin and cause of fires and explosions.",
    duration: "40 Hours",
    standards: "NFPA 1033",
    delivery: "Onsite"
  },
  {
    title: "NFPA 1030 Certified Fire Inspector",
    category: "Fire & Emergency Services",
    summary: "Conduct life safety inspections and enforce codes.",
    duration: "40 Hours",
    standards: "NFPA 1030",
    delivery: "Onsite, Live Online"
  },
  {
    title: "NFPA Certified Fire Inspector-Responder",
    category: "Fire & Emergency Services",
    summary: "Basic inspection principles for first responders.",
    duration: "16 Hours",
    standards: "NFPA 1030",
    delivery: "Onsite"
  },
  {
    title: "Certified Fire Protection Specialist Review",
    category: "Fire & Emergency Services",
    summary: "Intensive exam preparation for the CFPS credential.",
    duration: "16 Hours",
    standards: "NFPA CFPS",
    delivery: "Live Online"
  },
  {
    title: "NFPA 72 Certified Fire Alarm ITM Specialist",
    category: "Fire & Emergency Services",
    summary: "Inspection, testing, and maintenance of fire alarm systems.",
    duration: "24 Hours",
    standards: "NFPA 72",
    delivery: "Onsite"
  },
  {
    title: "NFPA 25/13 Certified Water-Based Fire Protection ITM",
    category: "Fire & Emergency Services",
    summary: "ITM for sprinkler and water-based systems.",
    duration: "24 Hours",
    standards: "NFPA 25, NFPA 13",
    delivery: "Onsite"
  },
  {
    title: "NFPA 1140/1051 Certified Wildfire Mitigation Specialist",
    category: "Fire & Emergency Services",
    summary: "Assess and mitigate wildfire risks in the WUI.",
    duration: "16 Hours",
    standards: "NFPA 1140, 1051",
    delivery: "Onsite, Live Online"
  },
  {
    title: "NFPA 1521 Incident Safety Officer",
    category: "Fire & Emergency Services",
    summary: "Manage scene safety during emergency operations.",
    duration: "24 Hours",
    standards: "NFPA 1521",
    delivery: "Onsite"
  },
  {
    title: "NFPA 600/1081 Facility Fire Brigades",
    category: "Fire & Emergency Services",
    summary: "Organization and management of industrial fire brigades.",
    duration: "24 Hours",
    standards: "NFPA 600, 1081",
    delivery: "Onsite"
  },
  {
    title: "NFPA 1002 Emergency Vehicle Driver/Operator",
    category: "Fire & Emergency Services",
    summary: "Safe operation of pumper and aerial apparatus.",
    duration: "40 Hours",
    standards: "NFPA 1002",
    delivery: "Onsite strictly"
  },
  {
    title: "NFPA 1010/1003 Airport Rescue Firefighter",
    category: "Fire & Emergency Services",
    summary: "Specialized ARFF response and aircraft hazards.",
    duration: "40 Hours",
    standards: "NFPA 1010, 1003",
    delivery: "Onsite"
  },
  
  // Technical & Hazmat
  {
    title: "NFPA 70E Electrical Safety in the Workplace",
    category: "Technical & Hazmat",
    summary: "Protect personnel from arc flash and shock hazards.",
    duration: "8 Hours",
    standards: "NFPA 70E",
    delivery: "Onsite, Live Online"
  },
  {
    title: "NFPA 1006 Technical Rescue",
    category: "Technical & Hazmat",
    summary: "Confined space, rope, and trench rescue operations.",
    duration: "40 Hours",
    standards: "NFPA 1006",
    delivery: "Onsite strictly"
  },
  {
    title: "Hazardous Materials Masterclass for Small Business",
    category: "Technical & Hazmat",
    summary: "EPA and OSHA compliance simplified for SMBs.",
    duration: "8 Hours",
    standards: "EPA, OSHA",
    delivery: "Live Online"
  },
  {
    title: "NFPA 472/1072 Hazardous Materials Awareness and Operations",
    category: "Technical & Hazmat",
    summary: "Initial response and defensive actions for hazmat incidents.",
    duration: "24 Hours",
    standards: "NFPA 472, 1072",
    delivery: "Onsite, Blended"
  },
  {
    title: "NFPA 472/1072 Hazmat Incident Commander",
    category: "Technical & Hazmat",
    summary: "Strategic management of hazardous materials emergencies.",
    duration: "16 Hours",
    standards: "NFPA 472, 1072",
    delivery: "Onsite"
  },

  // AI & Future
  {
    title: "Foundations of AI in the Workplace",
    category: "AI & Future Workforce",
    summary: "Practical AI concepts, prompt engineering, ethics, and productivity tools led by Linda Boes.",
    duration: "4 Hours",
    standards: "Corporate Best Practices",
    delivery: "Live Online, Onsite"
  },

  // Leadership & People
  {
    title: "Front Line Academy",
    category: "Leadership & People Development",
    summary: "Comprehensive development for new and emerging supervisors.",
    duration: "Multi-Day Series",
    standards: "Leadership",
    delivery: "Onsite"
  },
  {
    title: "An Emotionally Intelligent Approach to Safety",
    category: "Leadership & People Development",
    summary: "Using EQ to influence compliance and manage crisis stress.",
    duration: "8 Hours",
    standards: "EQ-i 2.0",
    delivery: "Onsite, Live Online"
  },
  {
    title: "Balanced Scorecard: Strategic Alignment",
    category: "Leadership & People Development",
    summary: "Connect daily operations to high-level strategic goals.",
    duration: "8 Hours",
    standards: "Strategy",
    delivery: "Onsite"
  },
  {
    title: "Managing Conflict: Turning Differences into Cooperation",
    category: "Leadership & People Development",
    summary: "Tools for de-escalation and constructive disagreement.",
    duration: "8 Hours",
    standards: "Communication",
    delivery: "Onsite, Live Online"
  },
  {
    title: "Generations in the Workplace",
    category: "Leadership & People Development",
    summary: "Strategies for leading and training a multi-generational workforce.",
    duration: "4 Hours",
    standards: "Culture",
    delivery: "Live Online"
  }
];